<template>
	<div>
		<div class="search_input_box">
		    <form action  @submit.prevent="toSearch">
		      <div class="search_input">
		        <i class="iconfont select-all" @click="toSearch">&#xe60e;</i>
		        <input
		              class="form-control search-field"
		              type="text"
		              name="q"
		              v-model.trim="keyWords"
		              placeholder=""
		              autocomplete="off"
		            />
		        <i v-if="keyWords!=''" class="iconfont clsose_dialog clearKeywordMin select-all" @click="hideSearchLayer">&#xe615;</i>
		        <!-- <i v-if="keyWords!=''" class="iconfont clsose_dialog clearKeywordMax  select-all" @click="clearKeyword">&#xe633;</i> -->
		      </div>
		    </form>
		</div>
	</div>
</template>

<script>
export default {
  name: "qiyu_getDetailById",
  data() {
  	return{
		keyWords:"",
	}
  },
  methods: {
	  toSearch(){
		  if(this.keyWords){
			  this.$router.push({
				  path:"/detail",
				  query:{
					  id:this.keyWords
				  }
			  })
		  }
	  },
	  hideSearchLayer(){
			console.log("hideSearchLayer")
			this.keyWords=""
	  },
	  clearKeyword(){
		  console.log("clearKeyword")
	  }
  }
}
</script>

<style scoped lang="scss" >
	.search_input_box{
	    background: #f5f5f5;
	    height: 3.75rem;
	    padding: .625rem 1.125rem;
	    form{
	      width: 100%;
	      height: 100%;
	    }
	    .search_input{
	      display: flex;
	      align-items: center;
	      border-radius: 3.125rem;
	      background: #fff;
	      width: 100%;
	      height: 100%;
	      .iconfont{
	        font-size: 1.25rem;
	        margin-left: 1.3125rem;
	        margin-right: .625rem;
	        cursor: pointer;
	      }
	      .search-field{
	        flex: 1;
	      }
	      .clsose_dialog{
	        font-size: 1.25rem;
	        margin-left: .625rem;
	        margin-right: 1.3125rem;
	        cursor: pointer;
	      }
	      .clearKeywordMax{
	        display: none;
	      }
	      .clearKeywordMin{
	        display: block;
	      }
	    }
	}
</style>